// extracted by mini-css-extract-plugin
export var accentColor = "#f44236";
export var categoryBorderColor = "#c4c8cd";
export var disableRipple = "false";
export var fontFamily = "\"Roboto\",\"Helvetica\",\"Arial\",sans-serif";
export var mainColor = "#6e6e6e";
export var mainContrast = "#fff";
export var panelBorderColor = "#c4c8cd";
export var secondaryColor = "#6e6e6e";
export var secondaryContrast = "#fff";